import PropTypes from 'prop-types';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import { useFormattedCurrencyDisplay } from '../hooks/useFormattedCurrencyDisplay';
import { EMPTY_PROPERTY_VALUE } from '../../constants/EmptyPropertyValue';
// @ts-expect-error dep untyped
import { FormattedCurrency as FormattedFractionalCurrency } from 'I18n/utils/internal/light/numberFormatters';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyCurrencyV2 = props => {
  const {
    className,
    placeholder = EMPTY_PROPERTY_VALUE,
    legacySimplifyCurrency,
    currencyProps = {}
  } = props;
  const {
    currencyValue,
    currencyCode,
    formattingOptions: {
      shouldSimplifyCurrency,
      fractionalCurrencyProps
    }
  } = useFormattedCurrencyDisplay({
    defaultCurrencyCode: currencyProps.currencyCode,
    shouldSimplifyCurrency: currencyProps.simplifyCurrency !== undefined ? currencyProps.simplifyCurrency : legacySimplifyCurrency
  });
  if (currencyValue === null) {
    return /*#__PURE__*/_jsx("span", {
      className: className,
      children: placeholder
    });
  }
  const CurrencyComponent = fractionalCurrencyProps ? FormattedFractionalCurrency : FormattedCurrency;
  if (!currencyCode) {
    return /*#__PURE__*/_jsx("span", {
      className: className,
      children: /*#__PURE__*/_jsx(CurrencyComponent, Object.assign({}, currencyProps, fractionalCurrencyProps, {
        simplifyCurrency: shouldSimplifyCurrency,
        value: currencyValue
        // Intentionally hide the currency symbol while loading,
        // or if we have an error loading the home currency
        // NOTE: use a blank space instead of an empty string to silence the
        // warning: 'I18n: Missing currencyCode in call to formatCurrency().'
        // It looks identical (browser collapses leading whitespace)
        ,
        unit: " "
      }))
    });
  }
  return /*#__PURE__*/_jsx("span", {
    className: className,
    "data-selenium-test": "currency-component-loaded",
    children: /*#__PURE__*/_jsx(CurrencyComponent, Object.assign({}, currencyProps, fractionalCurrencyProps, {
      currencyCode: currencyCode,
      simplifyCurrency: shouldSimplifyCurrency,
      value: currencyValue
    }))
  });
};
FormattedPropertyCurrencyV2.displayName = 'FormattedPropertyCurrencyV2';
FormattedPropertyCurrencyV2.propTypes = {
  className: PropTypes.string,
  currencyProps: PropTypes.object,
  placeholder: PropTypes.node,
  legacySimplifyCurrency: PropTypes.bool
};
export default FormattedPropertyCurrencyV2;